<template>
  <div id="app">
    <div class="bg">
		<img src="./static/img/Group122(1).png" alt="">
		<img src="./static/img/Group123(1).png" alt="">
        <div class="content" @mousewheel="wheel" id="page1">
			<!-- 顶部导航 -->
			<div class="top">
				<div class="left">
					<img src="./static/img/wangzhe@2x.png" alt="">
				</div>
				<div class="right">
					<div class="tabs">
						<my-tabs ref="tabs" :tabsList="['首页','兼职','关于我们']" :offsetTopList="offsetTopList" :padding="'4.17vw'" :fontSize="'1.56vw'"></my-tabs>
						<!-- <el-tabs class="el-tabs" v-model="toptab">
							<el-tab-pane class="el-tab" label="首页" name="首页"></el-tab-pane>
							<el-tab-pane class="el-tab" label="兼职" name="兼职"></el-tab-pane>
							<el-tab-pane class="el-tab" label="关于我们" name="关于我们"></el-tab-pane>
						</el-tabs> -->
					</div>
                    <!-- <div class="options">
						<div class="up">
							<div class="option" @click="optionClick(0,$event)">首页</div>
							<div class="option" @click="optionClick(1,$event)">兼职</div>
							<div class="option" @click="moveScreen">关于我们</div>
						</div>
						<div class="down" id="down"></div>
					</div> -->
					<div class="button" @click="download">
						<img src="@/static/img/Group1@2x.png" alt="">
						移动端
					</div>
				</div>
			</div>
			
			<!-- 回到顶部 -->
			<img src="./static/img/Group121.png" @click="backToTop" alt="">
			<!-- 第一页 -->
			<div class="page page1">
				<div class="box">
					<div class="left">
						<div class="font">
							<span class="bigfont">找好兼职</span>
							<span class="bigfont">就来<a>王者兼职</a>!</span>
							<span class="smallfont">专业的年轻人兼职赚钱平台</span>
							<span class="smallfont">为您提供免费、可靠、便捷的线上线下兼职服务</span>
						</div>
						<div class="button">
							<div class="buttonDiv" @click="download">
								<span>寻找兼职</span>
								<img src="./static/img/Polygon1@2x.png" alt="">
							</div>
							<div class="buttonDiv" style="background: #212F46;" @click="download">
								<span>发布兼职</span>
								<img src="./static/img/Polygon1@2x.png" alt="">
							</div>
						</div>
					</div>
					<div class="right">
						<img src="./static/img/shouye@2x.png" alt="">
					</div>
				</div>
				<img src="./static/img/Group5@2x.png" alt="" class="mouseImg">
				<div id="page2"></div>
			</div>
			<!-- 第二页	 -->
			<div class="page page2">
				<div class="box">
					<div class="left">
						<img src="./static/img/Group19@2x.png" alt="">
						<span>招聘企业经过实名认证</span>
						<span>人工审核、安全可靠</span>
					</div>
					<div class="right">
						<img src="./static/img/Group72@2x.png" alt="">
					</div>
				</div>
				<img src="./static/img/Group5@2x.png" alt="" class="mouseImg" >
				<div id="page3"></div>
			</div>
			<!-- 第三页	 -->
			<div class="page page3">
				<div class="box">
					<div class="left">
						<img src="./static/img/Group78@2x.png" alt="">
						<!-- <img src="./static/img/Group23@2x.png" alt="">
						<img src="./static/img/Group24@2x.png" alt="">
						<img src="./static/img/Group53@2x.png" alt=""> -->
					</div>
					<div class="right">
						<img src="./static/img/Group31@2x.png" alt="">
						<span>高精准智能推荐，各行各业</span>
						<span>快速申请，不愁没工作</span>
					</div>
				</div>
				<img src="./static/img/Group5@2x.png" alt="" class="mouseImg">
				<div id="page4"></div>
			</div>
			<!-- 第四页 -->
			<div class="page page4">
				<div class="box">
					<div class="left">
						<img src="./static/img/Group75@2x.png" alt="">
						<span>在家做、在本地、暑期兼职</span>
						<span>周末兼职、填满碎片时间</span>
					</div>
					<div class="right">
						<img src="./static/img/Group57@2x.png" alt="">
						<!-- <img src="./static/img/Group32@2x.png" alt="">
						<img src="./static/img/Group33@2x.png" alt=""> -->
					</div>
				</div>
				<img src="./static/img/Group5@2x.png" alt="" class="mouseImg" id="page5">
				
			</div>
			<!-- 第五页 -->
			<div class="page page5">
				<div class="box">
					<span>兼职分类</span>
					<div class="job">
						<div class="tabs">
							<!-- <my-tabs2 
							:tabsList="['全部','宅家兼职','本地兼职','线上兼职','众包任务','全部岗位']"
							:padding="'4.17vw'" :fontSize="'1.25vw'" :lineWidth="24"></my-tabs2> -->
							<el-tabs v-model="jobType">
								<el-tab-pane label="全部" name="全部"></el-tab-pane>
								<el-tab-pane label="宅家兼职" name="宅家兼职"></el-tab-pane>
								<el-tab-pane label="本地兼职" name="本地兼职"></el-tab-pane>
								<el-tab-pane label="线上兼职" name="线上兼职"></el-tab-pane>
								<el-tab-pane label="众包任务" name="众包任务"></el-tab-pane>
								<el-tab-pane label="全部岗位" name="全部岗位"></el-tab-pane>
							</el-tabs>
						</div>
						<div class="jobCards">
							<job-card v-for="item,index in jobCardList" :key="index"></job-card>
						</div>
						
					</div>
					<div id="page6" style="margin-top: 10vw;"></div>
					
				</div>
			</div>
			<!-- 第六页 -->
			<div class="page6">
				<div class="row1">
					<span>关于我们</span>
				</div>
				<div class="row2">
					<img src="./static/img/Ellipse25@2x.png" alt="">
					<div class="text">
						<span>王者兼职创立于2021年，是新型灵活用工找兼职</span>
						<span>发招聘的平台深受年轻人的信任和喜爱</span>
						<span>我们已为上万企业提供兼职招聘服务，有效降低用</span>
						<span>工成本提升经营效率，为年轻人打造多样化的兼职赚</span>
						<span>零花钱的平台</span>
					</div>
				</div>
				<div class="row3">
					目前已有<span>7、</span><span>128、</span><span>675</span>用户通过平台找到合适的兼职
				</div>
				<div class="row4">
					找好兼职，来王者兼职
				</div>
				<div class="row5">
					<div class="left">
						<span>二维码：</span>
						<div class="img">
							<img src="./static/img/WechatIMG90.jpeg" alt="">
						</div>
						
					</div>
					<div class="right">
						<div>联系我们</div>
            <div>官方网站：http://www.xuniu.website</div>
            <div>客服QQ：2691133658</div>
            <div>客服微信：yaya19003</div>
					</div>
				</div>
				<div class="bottom">
					<span>Copyright️©2021 www.xuniu.website</span>
					<span>成都迅牛网络科技有限公司 版权所有</span>
					<span>ICP证：<a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备19016799号</a></span>
				</div>
			
			</div>
			
		</div>
      </div>
  </div>
</template>

<script>
import myTabs from './components/tabs.vue'
import jobCard from './components/jobCard.vue'

export default {
	name: 'App',
	data(){
		return{				
			toptab:'首页',
			jobType:'全部',
			tabIndex:0,
			offsetTopList:[],
			jobCardList:[1,1,1,1,1,1],
			page:0,
			pageList:['#page1','#page2','#page3','#page4','#page5','#page6'],
			topHeight:0,
		}
	},
	components:{
		jobCard,
		myTabs,
	},
	mounted(){
		// this.topHeight=document.getElementsByClassName('top')[0].clientHeight
		// this.offsetTopList.push(document.getElementById('page1').offsetTop)
		// this.offsetTopList.push(document.getElementById('page2').offsetTop)
		// this.offsetTopList.push(document.getElementById('page3').offsetTop)
		// this.offsetTopList.push(document.getElementById('page4').offsetTop)
		// this.offsetTopList.push(document.getElementById('page5').offsetTop)
		// this.offsetTopList.push(document.getElementById('page6').offsetTop)
		// console.log(this.offsetTopList);
		this.$bus.$on('pageChange',(index)=>{
			console.log(index);
			this.page=index
		})
		
		// let that=this
		// document.onmousewheel=function(){
		// 	console.log(event.deltaY)
		// 	if(event.deltaY>0 && that.page<5){
		// 		// let offsetTop=window.screenTop;
		// 		// let clientHeight=document.documentElement.clientHeight;
				
		// 		that.page++
				
		// 		window.scrollTo({
		// 			top:that.offsetTopList[that.page]-that.topHeight,
		// 			behavior:'smooth'
		// 		})
		// 	}else if(event.deltaY<0 && that.page>0){
		// 		// let offsetTop=window.screenTop;
		// 		// let clientHeight=document.documentElement.clientHeight;
		// 		that.page--
		// 		window.scrollTo({
		// 			top:that.offsetTopList[that.page]-that.topHeight,
		// 			behavior:'smooth'
		// 		})
				
		// 	}
		// 	console.log(that.page);
		// }	
		
	},
    methods:{
		next(){
			this.page++
			console.log(this.offsetTopList[this.page]-this.topHeight);
			
			window.scrollTo(0,this.offsetTopList[this.page]-this.topHeight)
		},
		download(){
			window.location.href="http://global.xuniuwang.com/king_job/pkg/king_job.apk"
		},
		wheel(e){
			// console.log('e.deltaY',e.deltaY)
			// console.log('this.page',this.page);
			// console.log('document.documentElement.scrollTop',document.documentElement.scrollTop);
			if(e.deltaY>0 && this.page<5){
				this.page++
				//console.log(this.offsetTopList[this.page]-this.topHeight);
				setTimeout(()=>{
					window.location.href=this.pageList[this.page]
					if(this.page===0){
						this.$refs.tabs.tabIndexChange(0)
					}else if(this.page===4){
						this.$refs.tabs.tabIndexChange(1)
					}else if(this.page===5){
						this.$refs.tabs.tabIndexChange(2)
					}
				},500)
				// window.scrollTo(0,this.offsetTopList[this.page]+30*e.deltaY.toFixed(0)-this.topHeight)
				
			}else if(e.deltaY<0 && this.page>0){
				this.page--
				setTimeout(()=>{
					window.location.href=this.pageList[this.page]
					if(this.page===0){
						this.$refs.tabs.tabIndexChange(0)
					}else if(this.page===4){
						this.$refs.tabs.tabIndexChange(1)
					}else if(this.page===5){
						this.$refs.tabs.tabIndexChange(2)
					}
				},500)
				// window.scrollTo(0,this.offsetTopList[this.page]+30*e.deltaY.toFixed(0)-this.topHeight)
			}
			
			
			// let scrollTop=document.documentElement.scrollTop
			// if(this.tabIndex!==0 && scrollTop<this.offsetTopList[0]){
			// 	this.$refs.tabs.tabIndexChange(0)
			// 	this.tabIndex=0
			// }else if(this.tabIndex!==1 && scrollTop>=this.offsetTopList[0] && scrollTop<this.offsetTopList[1]){
			// 	this.$refs.tabs.tabIndexChange(1)
			// 	this.tabIndex=1
			// }else if(this.tabIndex!==2 && scrollTop>=this.offsetTopList[1]){
			// 	this.$refs.tabs.tabIndexChange(2)
			// 	this.tabIndex=2
			// }
		},
		backToTop(){
			this.$refs.tabs.tabClick(0)
		}
    }
}
</script>

<style lang="scss">
*{
	margin: 0; 
	scroll-behavior: smooth;
}
.bg{
    position: relative;
    width: 100%;
	background-color: rgba(255,255,255,0.1);
    >img:nth-of-type(1){
		width: 100vw;
		height: 168.7vw;
		z-index: -1;
		position: absolute;
		top: 0;
		left: 0;
	}
	>img:nth-of-type(2){
		width: 100vw;
		height: 205vw;
		z-index: -1;
		position: absolute;
		top: 168.7vw;
		left: 0;
	}
    .content{
        width: 100%;
        height: 100%;
		>img{
			width: 5.1vw;
			height: 5.1vw;
			position: fixed;
			bottom: 10vw;
			right: 2.5vw;
			cursor: pointer;
		}
		
		.top{
			position: sticky;
			top:0;
			width:inherit;
			display: flex;
			justify-content: space-between;
			align-content: center;
			z-index: 10;
			background-color: rgba(242, 246, 255, 1.0);
			
			
			.left{
				margin:2.5vw 5vw;
				
				>img{
					width: 9.58vw;
					height: 2.5vw;
				}
				
				
				font-size: 2.5vw;
				//font-family: ZCOOL KuaiLe-Regular, ZCOOL KuaiLe;
				font-family:  cursive;
				font-weight: 400;
				color: #212F46;
			}

			.right{
				display: flex;
				align-items: center;
				
				
				.tabs{
					 /deep/ .el-tabs__item{
						font-size: 1.56vw; 
						line-height: 2vw;
						height: auto;
						padding-left: 1.5vw;
					}
					/deep/ .el-tabs__item:nth-of-type(2){
						padding-left: 0;
					}
					/deep/ .el-tabs__header{
						margin: 0;
					}
					/deep/ .el-tabs__nav-wrap::after {
						
						height: 0.2vw;
						background-color: #FFFFFF;
					}
					/deep/ .el-tabs__active-bar{
						height:0.2vw ;
					}
				}
				
				.options{
					position: relative;
					
					.up{
						display: flex;
						
						.option{
						margin-left: 4.17vw;
						font-size: 1.56vw;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #212F46;
						}
					}
				}

				.down{
					width:2vw;
					height: 0.2vw;
					background-color: #212F46;
					position: absolute;
					left: 18.5%;
					transition: 0.1s;
					
				}
			

				.button{
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					width:8.9vw;
					height: 2.76vw;
					margin-left: 3.59vw;
					margin-right: 1.77vw;
					
					background: #0B4EF4;
					box-shadow: 0px 10px 19px 1px rgba(11,78,244,0.24);
					border-radius: 1.46vw;
					
					font-size: 1.56vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #FFFFFF;
					>img{
						width:1.18vw;
						height: 1.81vw;
						margin-right: 0.26vw;
					}
				}
				.button:hover{
					opacity: 0.9;
				}
			}
		}
		
		.page{
			width: 100%;
			height: 53vw;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			
		}
		
		.mouseImg{
			width: 1.64vw;
			height: 4.06vw;
			margin-top: 5vw;
		}
		
		.page1{
			.box{
				display: flex;
				align-items: center;
				.left{
					margin-right: 10vw;
					.font{
						display: flex;
						flex-direction: column;
						
						.bigfont{
							font-size: 3.96vw;
							font-family: Source Han Sans CN-Bold, Source Han Sans CN;
							font-weight: bold;
							color: #202F44;
							>a{
								color: #0083F1 ;
							}
						}
						.smallfont{
							font-size: 1.25vw;
							font-family: Source Han Sans CN-Medium, Source Han Sans CN;
							font-weight: 500;
							color: #546176;
						}
					}
					.button{
						display: flex;
						margin-top: 2vw;
						
						.buttonDiv{
							cursor: pointer;
							width: 12vw;
							height: 3.125vw;
							margin-right: 2vw;
							display: flex;
							justify-content: center;
							align-items: center;
							background: #0B4EF4;
							border-radius: 2.16vw;
							
							>span{
								margin-right: 1vw;
								font-size: 1.25vw;
								font-family: Source Han Sans CN-Medium, Source Han Sans CN;
								font-weight: 500;
								color: #FFFFFF;
							}
							>img{
								width: 0.625vw;
								height: 1.04vw;
							}
						}
						.buttonDiv:hover{
							opacity: 0.9;
						}
					}
					
				}
						
				.right{
					
					>img{
						width: 16.93vw;
						height: 36.61vw;
					}
				}
			}
		}
		
		.page2{
			
			.box{
				display: flex;
				.left{
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					margin-right: 10vw;
					
					>img{
						width: 31.46vw;
						height: 9.64vw;
					}
					>span{
						font-size: 3vw;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #546176;
					}
				}
				
				.right{
					
					>img{
						width: 33.28vw;
						height: 22.45vw;
					}
					
				}
			}
		
		}
	
		.page3{
			justify-content: flex-start;
			.box{
				display: flex;
				
				.left{
					position: relative;
					margin-right: 10vw;
					>img{
						width: 16.4vw;
						height: 6.15vw;
					}
					>img:nth-of-type(1){
						width: 16.93vw;
						height: 36.62vw;
					}
					>img:nth-of-type(2){
						position: absolute;
						top: 12vw;
						left: 2.8vw;
					}
					>img:nth-of-type(3){
						position: absolute;
						top: 18vw;
						left: 4.9vw;
					}
					>img:nth-of-type(4){
						position: absolute;
						top: 24vw;
						left: 6.6vw;
					}
				}
				.right{
					margin-top: 5vw;
					display: flex;
					flex-direction: column;
					>img{
						width: 20vw;
						height: 7.5vw;
					}
					>span{
						font-size: 3vw;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #546176;
					}
					
				}
			}
		}
	
		.page4{
			.box{
				display: flex;
				align-items: center;
				.left{
					margin-top: 2vw;
					margin-right: 10vw;
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					>img{
						width: 26.2vw;
						height: 9.64vw;
					}
					>span{
						font-size: 3vw;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #546176;
					}
				}
				.right{
					position: relative;
					>img{
						width: 16.93vw;
						height: 36.61vw;
					}
					>img:nth-of-type(2){
						width: 16.72vw;
						height: 5.94vw;
						position: absolute;
						top: 9vw;
						left: -3.95vw;
					}
					>img:nth-of-type(3){
						width: 16.72vw;
						height: 3.49vw;
						position: absolute;
						top:14.5vw;
						left: 7.3vw;
					}
				}
				
			}
		}
	
		.page5{
			justify-content: flex-start;
			.box{
				margin-top: 2vw;
				display: flex;
				flex-direction: column;
				align-items: center;
				>span{
					font-size: 3.33vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #212F46;
				}
				.tabs{
					margin: 1vw 0;
				}
				.job{
					/deep/ .el-tabs__item{
						font-size: 1.56vw; 
						line-height: 2vw;
						height: 2vw;
						padding-left: 0vw;
					}
					/deep/ .el-tabs__item:nth-of-type(2){
						padding-left: 0;
					}
					/deep/ .el-tabs__header{
						margin: 0;
					}
					/deep/ .el-tabs__nav-wrap::after {
						height: 0.2vw;
						background-color: #FFFFFF;
					}
					/deep/ .el-tabs__active-bar{
						height:0.2vw ;
					}
					
					
					
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 75vw;
					margin-top:3vw ;
					padding:1vw 0 2vw;
					background: rgba(255,255,255,0.3);
					border-radius: 18px 18px 18px 18px;
					border: 0.5vw solid #32B1F4;
					
					.jobCards{
						display: flex;
						flex-wrap: wrap;
						justify-content: center;
						
					}
				}
			}
		}
		
		.page6{
			display: flex;
			flex-direction: column;
			align-items: center;
			
			.row1{
				margin : 3vw 0;
				margin-top: 10vw;
				>span{
					font-size: 3.33vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #212F46;
				}
			}
			
			
			.row2{
				display: flex;
				align-items: center;
				margin-bottom: 10.42vw;
				>img{
					width: 25.42vw;
					height: 19.375vw;
				}
				.text{
					display: flex;
					flex-direction: column;
					
					font-size: 1.67vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #212F46;
					
					>span:nth-of-type(1){
						margin-left: 1.5vw;
					}
					>span:nth-of-type(3){
						margin-left: 1.5vw;
						margin-top: 1vw;
					}
				}
			}
		
			.row3{
				margin-bottom: 10.42vw;
				font-size: 3vw;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #333333;
				>span{
					font-size: 3.33vw;
					font-family: DIN-Bold, DIN;
					font-weight: bold;
					color: #0B4EF4;
				}
				>span:nth-of-type(1){
					margin-left: 2vw;
				}
				>span:nth-of-type(3){
					margin-right: 2vw;
				}
			}
			
			.row4{
				margin-bottom: 5vw;
				font-size: 3vw;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #212F46;
			}
			
			.row5{
				margin-bottom: 5vw;
				width: 80vw;
				display: flex;
        justify-content: space-between;
				align-items: center;
				.left{
					
					>span{
						font-size: 1.67vw;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #212F46;
					}
					.img{
						display: flex;
						justify-content: center;
						align-items: center;
						width: 10vw;
						height: 10vw;
						background: #FFFFFF;
						box-shadow: 0px 0px 8px 0px rgba(0,63,226,0.25);
						border-radius: 8px;
						>img{
							width: 8.08vw;
							height: 8.08vw;
						}
					}
				}
				
				.right{
					margin-left: 15vw;
					font-size: 1.2vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #212F46;
          text-align: right;
          >div {
            margin-bottom: 1.5vw;
            &:nth-child(1) {
              font-size: 1.67vw
            }
          }
				}
			}
			
			.bottom{
				margin-bottom: 5vw;
				>span{
					font-size: 1.25vw;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #8A97A9;
				}
				>span:nth-of-type(2){
					margin: 0 1vw;
				}
				
			}
		}
	
	}
}

</style>
